import { forwardRef, CSSProperties } from 'react';

import { Icon } from '@beeline/design-system-react/extracted-styles';

import cn from 'classnames';

import { CustomIconProps } from './CustomIcon.types';
import styles from './styles.module.scss';

export const CustomIcon = forwardRef<HTMLDivElement, CustomIconProps>(
  ({ className, color, background, ...rest }, ref) => {
    const convertColor = (varColor?: string): string => {
      const cssColor = varColor?.replace('$', '--');

      return `var(${cssColor})`;
    };

    return (
      <Icon
        className={cn(styles.iconWrap, className)}
        contained
        ref={ref}
        style={
          {
            '--color': convertColor(color),
            '--bgc': convertColor(background),
          } as CSSProperties
        }
        {...rest}
      />
    );
  }
);

CustomIcon.displayName = 'CustomIcon';
